import React, { useEffect, useState } from 'react';
import { Dot } from 'components/SearchForm/SearchResults/Dot';
import { Link } from 'react-router-dom';
import apiService from 'services/apiService';

const tila_merkit = {
  Käsittelyssä: '#FDF148',
  Käynnissä: '#A4F1F9',
  Hyväksytty: '#B3F4A7',
  Suunnitteilla: '#FFC6FF',
  Rauennut: '#FFFFFF',
  'Hyväksytty muutettuna': '#75FFD1',
  'Hyväksytty kiireellisenä': '#B9FF1E',
  'Käsittely päättynyt': '#FFCC84',
  Päättynyt: '#FFCC84',
};

const NewProjectsBox = ({ pageData, setIsLoading }) => {
  const [boxData, setBoxData] = useState([]);

  const keywordParams = pageData.keywords
    // convert to params
    .map((word) => '&asiasanat=' + word)
    .join('')
    .replace('&', '?'); // replace first match

  useEffect(() => {
    // fetch data, convert it into usable objects,
    // and save to state
    const fetchProposalData = async () => {
      try {
        const results = await apiService.fetchData(
          'search/hallituksen_esitykset' + keywordParams,
        );
        return results.hits.hits;
      } catch (err) {
        console.error(err);
        return [];
      }
    };

    const parseData = (rawData) => {
      try {
        const dataObjects = rawData
          .map((entry) => {
            const { _id: id, _source: source } = entry;

            if (source === undefined) {
              return null;
            }

            const status = source['asian_tila'].trim();

            return {
              id,
              tunnus: source['tunnus'],
              title: source['title'],
              status: status,
              status_color: tila_merkit[status],
            };
          })
          .filter((entry) => entry !== null);

        return dataObjects;
      } catch (err) {
        console.error(err);
        return [];
      }
    };

    // async returns a Promise, so use then
    fetchProposalData()
      .then((data) => {
        const parsed = parseData(data);
        setBoxData(parsed);
      })
      .finally(() => setIsLoading(false));

    // cleanup on unmount
    return () => {
      setBoxData([]);
    };
  }, [pageData]);

  return (
    <div className="smaller-font">
      {boxData.map((item) => (
        <p key={item.id}>
          <span style={{ display: 'block' }}>
            <Dot color={item.status_color} />
            {item.status}
          </span>
          <Link
            to={`/asiakirjat/hallituksen-esitykset/${item.id}`}
          >
            {item.tunnus}
          </Link>
          : {item.title}
        </p>
      ))}
    </div>
  );
};

export default NewProjectsBox;
